<template>
  <div>
    <!-- <div class="tip" v-show="isNeedRead">
      <img src="../assets/image/attention_icon.png" alt="icon">
      请阅读完通知后点击已读
    </div> -->
    <div class="realBody">
      <div class="title_section">
        <h1>{{title}}</h1>
        <div class="subtitle">
          <span>{{time}}</span>
        </div>
      </div>
      <div class="body_section" id="body_section">
        <div class="body_content" v-html="content"></div>
        <p class="notice-community-name-flag" v-if="communityName"><span></span>{{communityName}}<span></span></p>
      </div>
    </div>
    <div class="btn-height" v-if="isNeedRead"></div>
    <div class='noData' v-show="false">
      <img src='../assets/image/nothing.png' style='width: 150px;padding-top: 35%' />
      <span class='noText'>暂无内容</span>
    </div>
    <div class="btn-wrapper" v-if="isNeedRead">
      <div class="btn" @click="read">
        点击签收
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/script/util'
import '@/style/frozen.css'
import '@/style/base.css'
export default {
  name: '', // 通知详情
  data () {
    return {
      title: '',
      time: '',
      content: '',
      communityName: '',
      isNeedRead: false, // 是否需要读取信息
      loading: false // 已读loading
    }
  },
  created: function () {
    document.title = '通知详情'
    this.fetchDetail()
  },
  methods: {
    read: function () {
      let params = {
        noticeId: api.getVal('noticeId'),
        sendType: api.getVal('sendType')
      }
      api.ReadNoticeDetail(params).then(res => {
        // 加个桥，已签收
        if (window.WebViewJavascriptBridge) {
          window.WebViewJavascriptBridge.callHandler('_app_noticeSigned', api.getVal('noticeId'))
        }
        this.fetchDetail()
      })
    },
    fetchDetail: function () {
      // 请求通知详情数据
      this.loading = true
      let params = {
        noticeId: api.getVal('noticeId'),
        sendType: api.getVal('sendType'),
        sign: api.getVal('signType')
      }
      api.GetNoticeDetail(params)
        .then(res => {
          this.loading = false
          this.title = res.noticeTitle
          document.title = res.noticeTitle
          if (window.WebViewJavascriptBridge) {
            window.WebViewJavascriptBridge.callHandler('_app_setTitle', document.title)
          }
          this.time = res.intime
          this.content = res.noticeContent
          this.communityName = res.communityName
          // 0不需要签收 1未签收 2已签收
          // 只有1是需要显示已读操作的
          this.isNeedRead = res.signStatus === 1
          this.$nextTick(() => {
            this.bindFun()
          })
        }).then(res => {
          this.loading = false
        })
    },
    bindFun: function () {
      // 处理通知内容跳转
      let imgstr = []
      $('.body_section img').each(function (i) {
        imgstr.push($(this).attr('src'))
        let imgClass = $(this).parent().attr('class')
        if (imgClass === 'rightImg' || imgClass === 'leftImg' || imgClass === 'productImg' || imgClass === 'serviceIcon' || imgClass === 'jumpPromotion') {

        } else {
          $(this).click(function () {
            window.location = `image://?url=${imgstr}&currentIndex=${i}`
            // 阻止事件冒泡
            return false
          })
        }
      })
      // 内部跳转交互
      $('.body_section .jumpResult').each(function () {
        $(this).click(function () {
          var skipData = {
            pageId: $(this).attr('pageid'),
            H5NeedAuthorize: $(this).attr('h5needauthorize'),
            pageType: $(this).attr('pagetype'),
            detailId: $(this).attr('detailid'),
            url: $(this).attr('url'),
            isJoint: $(this).attr('isJoint')
          }
          if (window.WebViewJavascriptBridge) {
            // alert('我要跳转了')
            window.WebViewJavascriptBridge.callHandler('_app_page_jump', JSON.stringify(skipData))
          } else {
            alert('页面跳转调用失败')
          }
        })
      })
    }
  }
}

</script>
<style scoped>
.body_section {
  padding: 15px;
}

img {
  display: block;
  max-width: 100%;
  cursor: pointer;
}

.btn-height{
  height: 50px;
}
.title_section {
  padding: 0 15px;
  padding-top: 5px;
}

.title_section h1 {
  font-size: 24px;
  color: #404040;
  line-height: 34px;
  word-break: break-all;
}

.title_section .subtitle {
  font-size: 12px;
  color: #aaaaaa;
  line-height: 20px;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
}

.body_content {
  word-break: break-all;
}

.body_content p {
  margin: 10px 0;
  word-break: break-all;
}


.body_content img {
  text-align: center;
  margin: 0 !important;
  vertical-align: middle;
}

.noData {
  height: 100%;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  -webkit-align-items: center;
  align-items: center;
  flex-direction: column;
}

.noText {
  font-size: 15px;
  color: #aaaaaa;
  line-height: 21px;
  text-align: center;
  margin: 0 auto;
}

.btn {
  background: #FFC001;
  color: #333;
  font-size: 18px;
  height: 50px;
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.tip {
  display: flex;
  background-color: rgba(0,0,0,0.6);
  align-items: center;
  font-size: 12px;
  height: 35px;
  color: #fff;
  padding-left: 15px;
  position: fixed;
  bottom: 50px;
  width: 100%;
  z-index: 1000;
}
.tip img{
  width: 16px;
  height: 16px; 
  margin-right: 5px;

}
.btn-wrapper .btn {
  background: #FFC001;
  color: #fff;
  font-size: 18px;
  height: 44px;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius:22px;
}
.btn-wrapper {
  height: 60px;
  padding: 8px 15px;
  background: #fff;
  position: fixed;
  bottom: 0;
  display: flex;
  right: 0;
  left: 0;
  box-sizing: border-box;
  z-index: 1000;
}
.notice-community-name-flag{
    text-align: center;
    font-size: 12px;
    color: #aaa;
    padding-top: 15px;
    line-height: 30px;
}
.notice-community-name-flag span{
    display: inline-block;
  width: 2em;
  height: 0;
  border-top: 1px solid;
  vertical-align: middle;
  margin: 0 6px;
}
</style>
<style>
  body {
    background-color: #fff;
  }
  .body_content img{vertical-align: middle;}
  /*.body-wrapper{
    width: 100% !important;
  }*/
</style>



// WEBPACK FOOTER //
// notice.vue?a43ff0a6